<template>
    <div>
            <!-- <div class="otp-password-form" > -->
                    <AwesomeLoader :visible.sync="loading" :fullscreen="false" :darkMode="false"
                        message="Loading workspace..."
                        lottieUrl="https://assets6.lottiefiles.com/packages/lf20_x62chJ.json" />
                    <el-card class="register-card" v-if="pageType === 1 && !loading">
                        <div class="logo-container">
                            <img :src="getLogoInfo" alt="Kodefast Logo" class="logo" />
                            <p class="sub-title">Verify Your Email with OTP</p>
                        </div>
                            <el-form :model="form" :rules="rules" ref="formRef" label-position="top">
                                <el-form-item label="OTP" prop="otp" class="half">
                                    <el-input v-model="form.otp" placeholder="Enter OTP" />
                                    <span v-if="errors.otp">{{ errors.otp }}</span>
                                </el-form-item>
                                <el-form-item label="Password" prop="password">
                                    <el-input type="password" v-model="form.password" placeholder="********"
                                        :show-password="true" autocomplete="new-password" />
                                    <span v-if="errors.password">{{ errors.password }}</span>
                                </el-form-item>
                                <el-form-item label="Confirm Password" prop="confirmPassword">
                                    <el-input type="password" v-model="form.confirmPassword" placeholder="********"
                                        :show-password="true" autocomplete="new-confirm-password" />
                                    <span v-if="errors.confirmPassword">{{ errors.confirmPassword }}</span>
                                </el-form-item>
                                <el-button type="primary" class="submit-button" :loading="loading" @click="submitForm">
                                    {{ loading ? 'Submitting...' : 'Verify & Set Password' }}
                                </el-button>
                                <p v-if="successMessage" class="success">{{ successMessage }}</p>
                                <p v-if="apiError" class="error">{{ apiError }}</p>
                            </el-form>
                    </el-card>
                    <accessdenied v-else-if="pageType === 2 && !loading" :errorMessage="errorMessage" />

            <!-- </div> -->
        </div>
</template>
<script>
import app_config from "@/config/app";
import axios from "@/config/axios";
export default {
    name: "NoCodeBackground",
    data() {
        return {
            pageType: 0,
            config: {
                overlayColor: 'rgba(0, 0, 0, 0.2)' // Indigo semi-transparent
            },
            application_config: app_config,
            form: {
                otp: '',
                password: '',
                confirmPassword: '',
            },
            rules: {
                otp: [
                    { required: true, message: "OTP is required", trigger: "blur" },
                    { min: 6, message: "OTP must be at 6 characters", trigger: "blur" },
                ],
                password: [
                    { required: true, message: "Password is required", trigger: "blur" },
                    { min: 6, message: "Password must be at least 6 characters", trigger: "blur" },
                ],
                confirmPassword: [
                    { required: true, message: "Please confirm your password", trigger: "blur" },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.form.password) {
                                callback(new Error("Passwords do not match"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
            },
            errors: {},
            successMessage: '',
            apiError: '',
            loading: false,
        };
    },
    components: {
        accessdenied: () => import("./accessdenied.vue"),
        AwesomeLoader: () => import("./loader.vue")
    },
    computed:
    {
        getLogoInfo() {

            return this.company_info && this.company_info.logo ? `${this.application_config.S3_BUCKET_URL}/${this.company_info.logo}` : this.defaultLogo;

        }
    },

    created() {
        this.form.tenantCode = this.$route.params.unique_code;
    },

    async mounted() {
        document.documentElement.style.setProperty('--overlay-color', this.config.overlayColor);
        await this.validateCode();
    },

    methods: {
        async validateCode() {
            if (this.form.tenantCode) {
                try {
                    this.loading = true;
                    let info = await axios.get(`/ap/verify/${this.form.tenantCode}`);
                    // console.log("info",info.data.data);
                    this.registration_config = info.data.data;
                    this.company_info = info.data.data.company_id;
                    this.pageType = 1;
                    this.loading = false;
                    this.errorMessage = "";
                }
                catch (err) {
                    this.loading = false;
                    this.pageType = 2;
                    this.errorMessage = err?.response?.data?.message || err?.message;
                }
            }
        },

        async submitForm() {
            this.$refs.formRef.validate(async (valid) => {
                if (!valid) return;
                this.loading = true;
                this.apiError = '';
                this.successMessage = '';
                try {
                    const response = await axios.post('/application/user-email-verify', {
                        contact_id: this.$route.query?.id,
                        email: this.$route.query?.mail,
                        verification_code: this.form.otp,
                        password: this.form.password
                    });
                    if (response.data) {
                        this.successMessage = 'Your account has been verified and password set.';
                        this.$router.push({ path: `/signin/tenant` })
                    } else {
                        this.apiError = response.data.message || 'Something went wrong.';
                    }
                } catch (err) {
                    this.apiError = err.response?.data?.message || 'Server error.';
                } finally {
                    this.loading = false;
                }
            });
        },
    },
    beforeDestroy() {
    }

};
</script>


<style scoped>

.el-card__body,
  .el-main {
    padding: 0px !important;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .register-card {
    width: 100%;
    /* max-width: 440px; */
    /* padding: 20px 20px 25px; */
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  }
  .logo-container {
    text-align: center;
    margin-bottom: 18px;
  }
  
  .sub-title {
    font-size: 13px;
    color: #777;
    margin-top: 2px;
  }
  .row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  
  .half {
    flex: 1;
  }
  
  .code-group {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .submit-button {
    width: 100%;
    margin-top: 10px;
  }

  .logo {
    width: 10em;
    @media (max-width: 1024px) {
      width: 10em;
    }
    @media (max-width: 480px) {
      width: 8em;
    }
  }



  #phone {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
    
  .login-link {
    text-align: center;
    margin-top: 10px;
    font-size: 13px;
    color: #666;
  }
  
  .login-link a {
    color: #409eff;
    text-decoration: none;
  }
  
  .otp-password-form {
    max-width: 400px;
    margin: auto;
    padding: 20px;
  }
  
  .error {
    color: red;
    font-size: 13px;
  }
  
  .success {
    color: green;
    font-size: 14px;
    margin-top: 10px;
  }
</style>